/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react';

import cx from 'classnames';

import styles from './slider.module.scss';

interface SliderProps {
  // color: string;
  value: number;
  onChange: (e: number) => void;
  className?: string;
  style?: React.CSSProperties;
  color1?: string;
  color2?: string;

  // onMouseUp: () => void;
}

const Slider = forwardRef<HTMLInputElement, SliderProps>((props, ref) => {
  const { value, onChange, className, style, color1, color2 } = props;

  const [sliderValue, setSliderValue] = useState(0);

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSliderValue(parseInt(e.target.value));
    onChange(parseFloat(e.target.value));
  };

  //* by this function we can change the color of the slider track
  const getTrackColor = () => {
    const darkBlueColor = color1 || '#004080';
    //  color1="#6B3EB4"
    // color2="#6B3EB4"

    const lightBlueColor = color2 || '#1273EB';
    const grayColor = '#DADADA';

    // Calculate a ratio between 0 and 1 based on the sliderValue
    const ratio = sliderValue / 200;

    // Interpolate between red and blue based on the ratio
    const r = Math.round(
      (1 - ratio) * parseInt(lightBlueColor.slice(1, 3), 16) +
        ratio * parseInt(darkBlueColor.slice(1, 3), 16),
    );
    const g = Math.round(
      (1 - ratio) * parseInt(lightBlueColor.slice(3, 5), 16) +
        ratio * parseInt(darkBlueColor.slice(3, 5), 16),
    );
    const b = Math.round(
      (1 - ratio) * parseInt(lightBlueColor.slice(5, 7), 16) +
        ratio * parseInt(darkBlueColor.slice(5, 7), 16),
    );

    // Convert the interpolated RGB values back to a hex color
    const interpolatedColor = `#${r.toString(16).padStart(2, '0')}${g
      .toString(16)
      .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;

    // Calculate the position of the thumb within the range
    const thumbPosition = (sliderValue / 100) * 100;

    // Create a linear gradient background
    return `linear-gradient(90deg, ${darkBlueColor} 0%, ${interpolatedColor} ${thumbPosition}%, ${grayColor} ${thumbPosition}%, ${grayColor} 100%)`;
  };

  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  return (
    // <div className={styles.slider}>
    <input
      type="range"
      min="0"
      max="100"
      value={sliderValue}
      className={cx(styles.sliderInput, className)}
      onChange={handleSliderChange}
      // onMouseUp={(e) => props.onMouseUp()}
      style={{ background: getTrackColor(), ...style }}
      ref={ref}
    />
    // </div>
  );
});

export default Slider;
